import { required } from 'vuelidate/lib/validators'
import Api from '@/providers/Api'

export default {
    fields: {
        auditor: {
            dbNameField: 'auditor_id',
            label: 'Auditor',
            type: 'multiselect',
            showIf (model) {
                return true
            },
            multiselectOptions: {
                placeholder: 'Type auditor name to search',
                label: 'full_name_and_email',
                multiple: false,
            },
            async doSearch (query) {
                const filters = {
                    full_name_and_email: { field: 'full_name_and_email', type: 'hidden', value: query },
                    is_auditor: { field: 'is_auditor', type: 'hidden', value: '1' }
                }
                return Api.getItems(this, 'user', filters, ['full_name_and_email'])
            },
            validations: { required }
        },
        start_date: {
            label: 'Start Date',
            type: 'date',
            validations: { required }
        },
    }
}
